export const submitButton = { width: "121px", height: "36px" };
export const cancelButton = {
  marginRight: "1rem",
  borderRadius: "0",
  color: "#565656",
  height: "39px",
  width: "113px",
  backgroundColor: "#fff",
};

export const membershipPricing = {
  title: "Standard Membership",
  isInstallmentTransaction: false,
  amount: "",
  installmentDetailsTransaction: {
    numberOfInstallment: null,
    lastInstallmentDate: null,
  },
  openAmount: false,
  static: false,
  chargeDate: null,
  dueDate: null,
  isRecurring: false,
  note: "",
  tax_deductible: "",
  tax_type: "%",
  ledger: {
    id: "",
    name: "",
  },
  subLedger: {
    id: "",
    name: "",
  },
  addAmount: "",
  amountType: "$",
  order: 1,
};

export const addOns = {
  title: "Parking Permit",
  amount: "",
  order: 1,
  isRequired: false,
  openAmount: false,
  ledger: {
    id: "",
    name: "",
  },
  subLedger: {
    id: "",
    name: "",
  },
  tax_deductible: "",
  tax_type: "%",
  chargeDate: null,
  dueDate: null,
  isInstallmentTransaction: false,
  installmentDetailsTransaction: {
    numberOfInstallment: null,
    lastInstallmentDate: null,
  },
  note: "",
};

export const initialValues = {
  formName: "",
  showLastYear: false,
  validateContacts: false,
  validateFamily: false,
  showFinancialAid: false,
  enableHouseHold: false,
  formTags: [],
  formStartDate: null,
  formEndDate: null,
  alwaysAvailable: false,
  ledgersForCalculation: [],
  selectAllLedger: false,
  selectAllSubLedger: false,
  membershipPricing: [membershipPricing],
  membershipPriceType: "static",
  addOns: [addOns],
  ledgerForCalculation: {
    ledger: {
      id: "",
      name: "",
    },
    subLedger: {
      id: "",
      name: "",
    },
    dateRange: [null, null],
    fallbackAmount: "",
  },
};

export const getInitialValues = (memberById) => {
  if (!memberById?.result) return initialValues;

  const data = memberById.result;

  return {
    ...initialValues,
    ...data,
    ledgersForCalculation: data.ledgerForCalculation?.ledgers ?? [],
    membershipPricing: (data.membershipPricing || []).map((item) => ({
      ...membershipPricing,
      ...item,
      installmentDetailsTransaction: {
        ...membershipPricing.installmentDetailsTransaction,
        ...item.installmentDetailsTransaction,
      },
      ledger: {
        ...membershipPricing.ledger,
        ...item.ledger,
      },
      subLedger: {
        ...membershipPricing.subLedger,
        ...item.subLedger,
      },
      dateRange: [
        item.chargeDate ? new Date(item.chargeDate) : null,
        item.dueDate ? new Date(item.dueDate) : null,
      ],
    })),
    addOns: (data.addOns || []).map((item) => ({
      ...addOns,
      ...item,
      installmentDetailsTransaction: {
        ...addOns.installmentDetailsTransaction,
        ...item.installmentDetailsTransaction,
      },
      ledger: {
        ...addOns.ledger,
        ...item.ledger,
      },
      subLedger: {
        ...addOns.subLedger,
        ...item.subLedger,
      },
    })),
    formStartDate: data.formStartDate ? new Date(data.formStartDate) : null,
    formEndDate: data.formEndDate ? new Date(data.formEndDate) : null,
    ledgerForCalculation: {
      ...data.ledgerForCalculation,
      dateRange: [
        data.ledgerForCalculation?.dateRange?.from
          ? new Date(data.ledgerForCalculation?.dateRange?.from)
          : null,
        data.ledgerForCalculation?.dateRange?.to
          ? new Date(data.ledgerForCalculation?.dateRange?.to)
          : null,
      ],
    },
  };
};

// step 1
export const formInfo = (openTag, setOpenTag, values) => {
  return [
    {
      fieldKey: "text",
      title: "Form name",
      name: "formName",
      mandatory: true,
      placeholder: "Form Name",
      grid: 6,
    },
    {
      grid: 6,
    },
    {
      fieldKey: "date-time-range",
      title: "Open for submissions From",
      name: "formStartDate",
      mandatory: true,
      checkValidation: true,
      grid: 6,
      minDate: new Date(),
      showTimeSelect: false,
    },
    {
      fieldKey: "date-time-range",
      title: "Open for submissions Until",
      name: "formEndDate",
      mandatory: true,
      checkValidation: true,
      alwaysAvailable: true,
      grid: 6,
      disabled: !values?.formStartDate || values?.alwaysAvailable,
      minDate: new Date(
        new Date(values.formStartDate).getTime() + 24 * 60 * 60 * 1000
      ),
      showTimeSelect: false,
    },
    {
      fieldKey: "text",
      title: "Introduction message",
      name: "message",
      mandatory: false,
      maxLength: 300,
      placeholder: "We encourage you to consider a higher dues sponsorship level, as this helps us to have special programs and enhanced holiday celebrations.",
      grid: 12,
    },
    {
      fieldKey: "toggle",
      title: "Show last year membership details and status",
      name: "showLastYear",
    },
    {
      fieldKey: "toggle",
      title: "Validate Contact Information",
      name: "validateContacts",
    },
    {
      fieldKey: "toggle",
      title: "Enable Household Interests",
      name: "enableHouseHold",
    },
    {
      fieldKey: "toggle",
      title: "Family members validation",
      name: "validateFamily",
    },
    {
      fieldKey: "toggle",
      title: "Financial Aid",
      name: "showFinancialAid",
    },
    {
      fieldKey: "tag",
      name: "formTags",
      open: openTag,
      setOpen: setOpenTag,
      label: "Form Tags",
    },
  ];
};

// payment step 2
export const formRenewal = (
  handleCheckboxAction,
  membershipType
) => {
  const isStatic = membershipType === "static";

  return [
    {
      fieldKey: "radio",
      name: `membershipPriceType`,
      grid: 12,
      formsControls: [
        { value: "static", label: "Static" },
        {
          value: "dynamic",
          label: "Dynamic (based on last year)",
        },
      ],
      handleAction: () => handleCheckboxAction(),
      manuel: true,
    },
    ...(!isStatic
      ? [
        {
          fieldKey: "multi-ledger",
          title: "Ledger for Calculation",
          field: "ledgersForCalculation",
        },
        {
          fieldKey: "date-range",
          title: "Date Range",
          name: `ledgerForCalculation.dateRange`,
          mandatory: true,
          checkValidation: true,
        },
        {
          fieldKey: "text",
          type: "number",
          title: "Fallback Amount (when no history)",
          name: `ledgerForCalculation.fallbackAmount`,
          mandatory: true,
          placeholder: "Fallback Amount",
          checkValidation: true,
        },
        { type: "br", grid: 12 },
      ]
      : []),
  ];
};

export const formPayment = (
  activeTab,
  membershipType,
  ledgers,
  loading,
  handleAction,
  getOpenAmountChecked,
  isOpenAmount,
  getActiveValue,
  handleChange,
  handleStaticToggle
) => {
  const isStatic = membershipType === "static";
  return [
    ...(isStatic
      ? [
        {
          fieldKey: "text",
          type: "number",
          title: "Amount",
          name: `membershipPricing[${activeTab}].amount`,
          mandatory: true,
          placeholder: "Amount",
          disabled: getOpenAmountChecked,
          max: 1000000,
        },
        { grid: 6 },
      ]
      : []),
    ...(!isStatic
      ? [
        ...(getActiveValue?.static
          ? [
            {
              fieldKey: "text",
              type: "number",
              title: "Amount",
              name: `membershipPricing[${activeTab}].amount`,
              mandatory: true,
              placeholder: "Amount",
              max: 1000000,
            },
          ]
          : [
            {
              fieldKey: "text",
              type: "number",
              title: "Last Year Amount Increase By",
              placeholder: "Last Year Amount Increase By",
              name: `membershipPricing[${activeTab}].addAmount`,
              taxTypePath: `membershipPricing[${activeTab}].amountType`,
              mandatory: true,
              checkValidation: true,
              max: 1000000,
            },
          ]
        ),
        {
          fieldKey: "checkbox",
          title: "Static",
          name: `membershipPricing[${activeTab}].static`,
          grid: 6,
          showTopLabel: true,
          handleAction: handleStaticToggle,
        },
      ]
      : []),
    {
      fieldKey: "checkbox",
      title: "Recurring (monthly)",
      showTopLabel: "Recurring (monthly)",
      name: `membershipPricing[${activeTab}].isRecurring`,
      grid: 6,
      disabled: getActiveValue?.isInstallmentTransaction,
    },
    {
      fieldKey: "checkbox",
      title: "Open Amount",
      name: `membershipPricing[${activeTab}].openAmount`,
      grid: 6,
      showTopLabel: true,
      handleAction: handleAction,
      disabled: !getOpenAmountChecked ? isOpenAmount : false,
    },

    {
      fieldKey: "select",
      title: "Ledgers",
      options: ledgers ?? [],
      name: `membershipPricing[${activeTab}].ledger`,
      subField: `membershipPricing[${activeTab}].subLedger`,
      primaryLabelKey: "ledger_name",
      secondaryLabelKey: "sub_ledger_name",
      secondaryMapKey: "sub_ledgers",
      loading: loading,
      handleChange: handleChange,
    },
    {
      fieldKey: "text",
      type: "number",
      title: "Tax Deductible",
      placeholder: "Tax Deductible",
      name: `membershipPricing[${activeTab}].tax_deductible`,
      taxTypePath: `membershipPricing[${activeTab}].tax_type`,
      mandatory: true,
      checkValidation: true,
    },
    {
      fieldKey: "date-time-range",
      title: "Charge Date",
      name: `membershipPricing[${activeTab}].chargeDate`,
      mandatory: true,
      checkValidation: true,
    },
    {
      fieldKey: "date-time-range",
      title: "Due Date",
      name: `membershipPricing[${activeTab}].dueDate`,
      mandatory: true,
      checkValidation: true,
    },
    ...(getActiveValue?.isRecurring
      ? []
      : [
        {
          fieldKey: "installment",
          name: `membershipPricing[${activeTab}].isInstallmentTransaction`,
          installmentKey: `membershipPricing[${activeTab}].installmentDetailsTransaction`,
          grid: 12,
        },
      ]),
    { type: "br", grid: 12 },
    {
      fieldKey: "text",
      title: "Note",
      name: `membershipPricing[${activeTab}].note`,
      placeholder: "Note",
      grid: 12,
    },
  ];
};
// step 3
export const formAddOns = (
  activeTab,
  ledgers,
  loading,
  handleAction,
  getOpenAmountChecked,
  isRequires,
  isOpenAmount,
  handleChange
) => {
  return [
    {
      fieldKey: "text",
      type: "number",
      title: "Amount",
      name: `addOns[${activeTab}].amount`,
      mandatory: true,
      placeholder: "Amount",
      disabled: getOpenAmountChecked,
      max: 1000000,
    },
    { grid: 6 },
    {
      fieldKey: "checkbox",
      title: "Required",
      name: `addOns[${activeTab}].isRequired`,
      grid: 6,
      showTopLabel: true,
      disabled: getOpenAmountChecked,
    },
    {
      fieldKey: "checkbox",
      title: "Open Amount",
      name: `addOns[${activeTab}].openAmount`,
      grid: 6,
      showTopLabel: true,
      handleAction: handleAction,
      disabled: !getOpenAmountChecked
        ? isRequires
          ? true
          : isOpenAmount
        : false,
    },
    {
      fieldKey: "select",
      title: "Ledgers",
      options: ledgers ?? [],
      name: `addOns[${activeTab}].ledger`,
      subField: `addOns[${activeTab}].subLedger`,
      primaryLabelKey: "ledger_name",
      secondaryLabelKey: "sub_ledger_name",
      secondaryMapKey: "sub_ledgers",
      loading: loading,
      handleChange: handleChange,
    },
    {
      fieldKey: "text",
      type: "number",
      title: "Tax Deductible",
      placeholder: "Tax Deductible",
      name: `addOns[${activeTab}].tax_deductible`,
      taxTypePath: `addOns[${activeTab}].tax_type`,
      mandatory: true,
      checkValidation: true,
    },
    {
      fieldKey: "date-time-range",
      title: "Charge Date",
      name: `addOns[${activeTab}].chargeDate`,
      mandatory: true,
      checkValidation: true,
    },
    {
      fieldKey: "date-time-range",
      title: "Due Date",
      name: `addOns[${activeTab}].dueDate`,
      mandatory: true,
      checkValidation: true,
    },
    {
      fieldKey: "installment",
      name: `addOns[${activeTab}].isInstallmentTransaction`,
      installmentKey: `addOns[${activeTab}].installmentDetailsTransaction`,
      grid: 12,
    },
    { type: "br", grid: 12 },
    {
      fieldKey: "text",
      title: "Note",
      name: `addOns[${activeTab}].note`,
      placeholder: "Note",
      grid: 12,
    },
  ];
};

export const mapPricingItem = (item, isStatic, isNeed) => ({
  title: item?.title,
  isInstallmentTransaction: !!item?.isInstallmentTransaction,
  ...((isStatic || isNeed || item?.static) && { amount: item?.amount }),
  ...(item?.isInstallmentTransaction && {
    installmentDetailsTransaction: item?.installmentDetailsTransaction,
  }),
  openAmount: item?.openAmount,
  chargeDate: item?.chargeDate,
  dueDate: item?.dueDate,
  isRecurring: item?.isRecurring,
  ...(item?.note && { note: item?.note }),
  tax_deductible: item?.tax_deductible,
  tax_type: item?.tax_type,
  ledger: item?.ledger,
  ...(item?.subLedger?.id && { subLedger: item?.subLedger }),
  order: item?.order,
  ...(!isStatic && {
    static: item?.static,
    ...(!item?.static && {
      addAmount: item?.addAmount,
      amountType: item?.amountType,
    }),
  }),
  ...(isNeed && { isRequired: item?.isRequired }),
});

export function createTouchedShape(values) {
  if (Array.isArray(values)) {
    return values.map((item) => createTouchedShape(item));
  } else if (typeof values === "object" && values !== null) {
    return Object.keys(values).reduce((acc, key) => {
      acc[key] = createTouchedShape(values[key]);
      return acc;
    }, {});
  } else {
    return true;
  }
}
